<wb-spinner theme="light"></wb-spinner>